
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({})
/**
 * 参数说明
 * stepsList 渲染组件list 通过isComplete 字段控制是否完成
 * active 目前活跃项目
 *
 * **/
export default class BuilderV3Steps extends Vue {
  @Prop({
    type: Array,
    default: () => {
      return [
        {
          title: "考查项选择",
          isComplete: false
        },
        {
          title: "测评工具",
          isComplete: false
        },
        {
          title: "分数配置",
          isComplete: false
        }
      ];
    }
  })
  stepsList!: any[];
  @Prop({ type: Number, default: 1 }) active!: number;
  itemClick(index: number, item: any) {
    if (item.isComplete) {
      this.$emit("itemClick", index);
    }
  }
}
